<template>
  <div class="set-password">
    <van-nav-bar
      :title="lang.setPassword"
      :left-arrow="!$route.query.fromapp"
      @click-left="$router.go(-1)"
    />
    <div v-if="!isSuccess">
      <div class="main">
        <input
          v-model="newpsd"
          type="password"
          :placeholder="lang.newPassword"
        >
        <input
          v-model="renewpsd"
          type="password"
          :placeholder="lang.reNewPassword"
        >
      </div>
      <div class="btn-sub">
        <van-button
          :disabled="newpsd && renewpsd ? false : true"
          type="danger"
          size="large"
          @click="clickEdit"
        >
          {{ lang.confirm1 }}
        </van-button>
      </div>
    </div>
    <div
      v-else
      class="success"
    >
      <p>
        <span><van-icon name="success" /></span> <br>
        {{ lang.setPsdSuccess }}
      </p>
      <!-- 设置密码和更改密码接口一致  会导致设置密码token失效 -->
      <van-button
        type="danger"
        size="large"
        @click="goLogin()"
      >
        {{ lang.confirm }}
      </van-button>
    </div>
  </div>
</template>
<script>
import lang from './../../../common/language/editUser';
export default {
  data() {
    return {
      lang: lang,
      isSuccess: false,
      newpsd: '',
      renewpsd: ''
    };
  },
  methods: {
    goLogin() {
      this.pub.delCookie('ERnJaMWtkM');
      this.pub.delCookie('cEVaUDFrZ1kd0RA');
      if (navigator.userAgent.indexOf('house730') > -1) {
        let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
        const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
        if (isFlutter) {
          window.house730.postMessage(JSON.stringify({ type: 'jumpLogin', data: {} }));
        } else if (isAndroid) {
          window.house730.jumpLogin();
        } else {
          window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}));
        }
      } else {
        this.$router.push('/login/?tab=1');
      }
    },
    /**点击修改密码 */
    clickEdit() {
      if (this.newpsd !== this.renewpsd) {
        this.$notify(lang.newPsdError);
        return;
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(this.newpsd)) {
        this.$notify(lang.psdError);
        return;
      } 
        /**设置密码*/
        this.axios
          .post(this.pub.getApi().UpdateUserPassword, {
            newPassword: this.newpsd
          })
          .then(res => {
            if (res.data.code == 0) {
              this.isSuccess = true;
            }
          });
      
    }
  }
};
</script>
<style lang="scss" scoped>
.set-password {
  .main {
    padding: 33px 26px;
    overflow: hidden;
    input {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;
      border: none;
      border-bottom: 1px solid #eee;
      padding: 0 2px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .btn-sub {
    padding: 0 26px;
    p {
      line-height: 50px;
      color: #b2b2b2;
      font-size: 14px;
    }
  }
  .success {
    p {
      font-size: 20px;
      line-height: 48px;
      color: #333;
      padding: 50px 0 37px 0;
      span {
        margin-right: 6px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #4cd964;
        display: inline-block;
        vertical-align: middle;
        .van-icon-success {
          color: #fff;
          font-size: 26px;
          line-height: 48px;
        }
      }
    }
    padding: 0 26px;
  }
}
</style>
